import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { LeadFlowMonitorRun } from "@/lib/lead-flow-monitor-run";

/** The lead-flow monitor's last run, for System Health. RLS returns it to admins only. */
export function useLeadFlowMonitorRun({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: ["lead_flow_monitor_run"],
    enabled,
    staleTime: 60_000,
    // Picks up the next hourly run on a Dashboard left open (window refocus doesn't refetch here).
    refetchInterval: 5 * 60_000,
    queryFn: async (): Promise<LeadFlowMonitorRun | null> => {
      const { data, error } = await supabase
        .from("lead_flow_monitor_runs")
        .select("checked_at, status, incident_open")
        .eq("id", true)
        .maybeSingle();
      if (error) throw error;
      return data;
    },
  });
}
